function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MultipleFilterProduct = /*#__PURE__*/function () {
  function MultipleFilterProduct(options) {
    _classCallCheck(this, MultipleFilterProduct);
    this.container = options.container || null;
    this.founded = options.founded || null;
  }
  _createClass(MultipleFilterProduct, [{
    key: "getDataObjForAjax",
    value: function getDataObjForAjax(action, security, params) {
      return {
        'action': action,
        'security': security,
        'designers': params.designers,
        'max_price': params.inputMax,
        'min_price': params.inputMin,
        'max_page': params.maxPage,
        'next_page': params.nextPage,
        'cat': params.cat
      };
    }
  }, {
    key: "ajaxFilterProducts",
    value: function ajaxFilterProducts(action, security, params) {
      var filterData = this.getDataObjForAjax(action, security, params);
      console.log('ajaxFilterProducts');
      $.ajax({
        url: filter_params.ajaxurl,
        data: filterData,
        type: 'POST',
        success: function success(data) {
          if (data) {
            $('.js-loadmore-wrapper .container').remove();
            $('.founded-products .container').html('');
            $('.founded-products .container .founded-products__message').remove();
            $('.js-loadmore-wrapper').append($(data).filter('.ajax-product-filter-holder').html());
            $('.founded-products .container').append($(data).filter('.js-ajax-product-number').html());
          }
        }
      });
    }
  }, {
    key: "ajaxLoadMore",
    value: function ajaxLoadMore(action, security, params) {
      var filterData = this.getDataObjForAjax(action, security, params);
      $.ajax({
        url: filter_params.ajaxurl,
        data: filterData,
        type: 'POST',
        success: function success(data) {
          if (data) {
            $('.products-list__btn-wrap').remove();
            $('.products-list__row').append($(data).filter('.ajax-product-filter-holder').html());
            $('.container.js-loadmore-wrapper').append($(data).filter('.ajax-product-more-holder').html());
          }
        }
      });
    }
  }]);
  return MultipleFilterProduct;
}();
export { MultipleFilterProduct as default };